const footer_link = () => {
	const nav = document.querySelector('.js-footer-link');
	if(nav !== null){
		const path = location.pathname;
		const item = document.querySelectorAll('.c-footer-link__list__item');

		// カレント処理
		for (let i = 0; i < item.length; i++) {
			if(item[i].querySelector('a').getAttribute('href') === path){
				item[i].style.display = 'none';
			}
		}
		
	}
}